import React from "react";

const DividerSection = () => {
    return (
        <hr className="my-10 border-t-2 border-[#BBBBBB]" />
    )
}

export default DividerSection